/**
 * Progress Component Styles
 */

import { mode } from '../../system/color-mode';

export const progressStyles = {
  baseStyle: {
    track: {
      w: '40px',
      h: '20px',
      borderRadius: '20px',
      bg: 'gray.100',
      _focus: {
        boxShadow: 'none',
      },
    },
    filledTrack: {
      transition: 'all 0.3s',
      borderRadius: 'inherit',
      bg: 'brand.500',
    },
    label: {
      fontWeight: 'bold',
      fontSize: 'xs',
    },
  },

  sizes: {
    xs: {
      track: { h: '4px' },
    },
    sm: {
      track: { h: '8px' },
    },
    md: {
      track: { h: '12px' },
    },
    lg: {
      track: { h: '16px' },
    },
  },

  variants: {
    table: (props) => ({
      track: {
        borderRadius: '20px',
        bg: mode('blue.50', 'whiteAlpha.50')(props),
        h: '8px',
        w: '54px',
      },
      filledTrack: {
        bg: 'brand.500',
        borderRadius: '16px',
      },
    }),
  },

  defaultProps: {
    size: 'md',
    colorScheme: 'brand',
  },
};

export default progressStyles;
